var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsArtifact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.475L4 14.6C3.68333 14.4167 3.4375 14.175 3.2625 13.875C3.0875 13.575 3 13.2417 3 12.875V7.125C3 6.75833 3.0875 6.425 3.2625 6.125C3.4375 5.825 3.68333 5.58333 4 5.4L9 2.525C9.31667 2.34167 9.65 2.25 10 2.25C10.35 2.25 10.6833 2.34167 11 2.525L16 5.4C16.3167 5.58333 16.5625 5.825 16.7375 6.125C16.9125 6.425 17 6.75833 17 7.125V12.875C17 13.2417 16.9125 13.575 16.7375 13.875C16.5625 14.175 16.3167 14.4167 16 14.6L11 17.475C10.6833 17.6583 10.35 17.75 10 17.75C9.65 17.75 9.31667 17.6583 9 17.475ZM9 15.175V10.575L5 8.25V12.875L9 15.175ZM11 15.175L15 12.875V8.25L11 10.575V15.175ZM0 5V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H5V2H2V5H0ZM5 20H2C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V15H2V18H5V20ZM15 20V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H15ZM18 5V2H15V0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V5H18ZM10 8.85L13.95 6.525L10 4.25L6.05 6.525L10 8.85Z",
    fill: "#2E3944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArtifact);
export default __webpack_public_path__ + "static/media/icons_artifact.5898e727.svg";
export { ForwardRef as ReactComponent };